// Attributes
// data-entry-tool = [data-entry-tool-type] data-entry-tool-name
// data-entry-tool, data-entry-tool-type, data-entry-tool-name,
// data-cta-text, data-thank-you-slug, data-submission-callback-name
// data-attribution-survey-value

window.jet_setCtaText = function (formInstanceId) {
  var container = document.getElementById(formInstanceId);
  var ctaText = container.getAttribute('data-cta-text');
  if (!ctaText) return;
  var selector = '[id="' + formInstanceId + '"] button.hsfc-Button';
  var button = document.querySelector(selector);
  button.textContent = ctaText;
}

window.jet_setAttributionSurvey = function (formInstanceId, form) {
  var container = document.getElementById(formInstanceId);
  var attributionSurveyValue = container.getAttribute('data-attribution-survey-value');
  if (!attributionSurveyValue) return;
  form.setFieldValue("0-1/attribution_survey", attributionSurveyValue);
  var inputHidden = container.querySelector('input[name="0-1/attribution_survey"]');
  if (inputHidden) {
    var fieldWrapper = inputHidden.closest('.hsfc-Row');
    if (fieldWrapper) fieldWrapper.style.display = 'none';
  }
}

window.jet_setEntryTool = function (formInstanceId, form) {
  var container = document.getElementById(formInstanceId);
  var entryToolValue = container.getAttribute('data-entry-tool');
  var entryToolType = container.getAttribute('data-entry-tool-type');
  var entryToolName = container.getAttribute('data-entry-tool-name');
  if (entryToolValue) {
    form.setFieldValue("0-1/entry_tool", entryToolValue);
  } else if (entryToolType && entryToolName) {
    form.setFieldValue("0-1/entry_tool", '[' + entryToolType.toLocaleLowerCase() + '] ' + entryToolName);
  } else {
    form.setFieldValue("0-1/entry_tool", '[missing]');
  }
}

window.jet_setUtmParams = function (form) {
  var utmParams = window.JetConversions ? window.JetConversions.getUtm() : {};
  var fields = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  fields.forEach(function (key) {
    form.setFieldValue("0-1/" + key, utmParams[key] || "");
  });
}

window.jet_setJetId = function (form) {
  try {
    var jetId = window.JetConversions ? window.JetConversions.getJetId() : "";
    if (jetId) form.setFieldValue("0-1/jet_id", jetId);
  } catch (e) {
    // Field may not exist in form — ignore
  }
}

window.jet_setPosthogDistinctId = function (form, attempts) {
  if (typeof attempts === 'undefined') attempts = 0;
  var phId = null;
  if (window.posthog && typeof window.posthog.get_distinct_id === 'function') {
    phId = window.posthog.get_distinct_id();
  }
  if (phId) {
    form.setFieldValue("0-1/posthog_distinct_id", phId);
  } else {
    if (attempts >= 50) return;
    setTimeout(function () {
      window.jet_setPosthogDistinctId(form, attempts + 1);
    }, 100);
  }
}

window.jet_triggerLeadEvent = async function (form) {
  if (!window.JetConversions) {
    console.error('JetConversions tracker not loaded');
    return;
  }

  var valuesMap = await form.getFormFieldValues();
  var values = valuesMap.reduce(function (res, item) {
    res[item.name] = item.value;
    return res;
  }, {});

  await window.JetConversions.track('lead', {
    user_data: {
      email: values['0-1/email'],
      phone: values['0-1/phone'],
      first_name: values['0-1/firstname'],
      last_name: values['0-1/lastname'],
    },
    properties: {
      entryTool: values['0-1/entry_tool'],
      role: values['0-1/ruolo'],
      numberOfEmployee: values['0-1/contact_number_of_employees_new'],
      need: values['0-1/perche_ci_stai_contattando'],
      userAttribution: values['0-1/attribution_survey'],
      userAttributionOther: values['0-1/attribution_survey___altro'],
      email: values['0-1/email'],
      phone: values['0-1/phone'],
    },
  });
}

window.addEventListener("hs-form-event:on-ready", function (event) {
  var form = HubSpotFormsV4.getFormFromEvent(event);
  var instanceId = event.detail.instanceId;

  jet_setCtaText(instanceId);
  jet_setAttributionSurvey(instanceId, form);
  jet_setEntryTool(instanceId, form);
  jet_setUtmParams(form);
  jet_setJetId(form);
  jet_setPosthogDistinctId(form);
});

window.addEventListener("hs-form-event:on-submission:success", async function (event) {


  console.log('hs-form-event:on-submission:success');
  console.log('event', event);

  var form = HubSpotFormsV4.getFormFromEvent(event);
  var instanceId = event.detail.instanceId;

  var container = document.getElementById(instanceId);
  var thankYouSlugValue = container.getAttribute('data-thank-you-slug');
  var submissionCallbackName = container.getAttribute('data-submission-callback-name');

  await jet_triggerLeadEvent(form);

  if (submissionCallbackName) {
    await window[submissionCallbackName](form);
  } else {
    var domain = window.location.origin;
    if (thankYouSlugValue) {
      if (thankYouSlugValue.charAt(0) !== '/') {
        thankYouSlugValue = '/ty/' + thankYouSlugValue;
      }
    } else {
      thankYouSlugValue = '/thank-you';
    }
    window.location.href = domain + thankYouSlugValue;
  }
});